var _path;

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import * as React from "react";

function SvgPerson(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 20 22"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fill: "none",
    stroke: "#89959c",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeMiterlimit: 50,
    strokeWidth: 2,
    d: "M14.668 6c0 2.76-2.226 5-4.97 5C6.957 11 4.73 8.76 4.73 6s2.226-5 4.969-5c2.743 0 4.969 2.24 4.969 5zM1 21.001c0-6.082 3.893-7.391 8.696-7.391 4.802 0 8.695 1.309 8.695 7.391z"
  })));
}

export default SvgPerson;